module.exports = __webpack_public_path__ + "img/bg3.881a89c1.png";